export const CARE_COMPANY_ADD_URL_LIST = [
  { label: "직접입력", value: "1" },
  { label: "홈택스", value: "https://hometax.go.kr" },
  { label: "여신금융협회", value: "https://www.cardsales.or.kr" },
  { label: "공인인증서", value: "2" },
  { label: "네이버스토어", value: "https://sell.smartstore.naver.com" },
  { label: "토스페이먼츠", value: "https://pgweb.tosspayments.com" },
  { label: "배달의민족", value: "https://ceo.baemin.com" },
  { label: "요기요", value: "https://owner.yogiyo.co.kr" },
  { label: "쿠팡이츠", value: "https://store.coupangeats.com" },
]

export const CARE_COMPANY_MEMO_COMPLETED = [
  { label: "처리", value: "1" },
  { label: "미처리", value: "0" },
]

export const CARE_COMPANY_MEMO_FILTER_COMPLETED = [
  { label: "전체", value: "" },
  { label: "처리", value: "1" },
  { label: "미처리", value: "0" },
]